import { render, staticRenderFns } from "./EditarPasta.vue?vue&type=template&id=0f8b8d7c&scoped=true&"
import script from "./EditarPasta.vue?vue&type=script&lang=js&"
export * from "./EditarPasta.vue?vue&type=script&lang=js&"
import style0 from "./EditarPasta.vue?vue&type=style&index=0&id=0f8b8d7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8b8d7c",
  null
  
)

export default component.exports